import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { ActivationResponse } from '../shared/models/activation-response';
import { ActivationRequest } from '../shared/models/activation-request';

@Injectable({
  providedIn: 'root'
})
export class LicensingService {

  constructor(private httpClient: HttpClient) { }

  // Handle API errors
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      `${error.error}`);
  }


  public manualActivate(activation: ActivationRequest): Observable<ActivationResponse> {
    return this.httpClient.post<ActivationResponse>('/api/licensing/manualActivation', activation).pipe(
      retry(0),
      catchError(this.handleError)
    );
  }
 }
